import { render, staticRenderFns } from "./thirds_config_view.vue?vue&type=template&id=42d7ead0&scoped=true"
import script from "./thirds_config_view.vue?vue&type=script&lang=js"
export * from "./thirds_config_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d7ead0",
  null
  
)

export default component.exports